import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { loadingSelectors } from 'redux/selectors'

import FullScreenLoading from 'components/full_screen_loading/full_screen_loading'

class LoadingLayer extends Component {
	render() {
		if (this.props.show) {
			return <FullScreenLoading
				animation={this.props.animation}
				text={this.props.text}
				isTransparent={this.props.isTransparent}
			/>
		} else {
			return null
		}
	}
}

LoadingLayer.propTypes = {
	show: PropTypes.bool,
	text: PropTypes.string,
	animation: PropTypes.oneOf(['wheel', 'dots']),
	isTransparent: PropTypes.bool,
}

function mapStateToProps(state) {
	return loadingSelectors.loadingSelector(state)
}

export default connect(mapStateToProps, null)(LoadingLayer)
